import styled from 'styled-components';

export const ReportLifeEventBannerStyled = styled('div')({
  width: '100%',
  backgroundColor: '#DEE7FF',
  borderRadius: '4px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  '@media (min-width: 744px)': {
    alignItems: 'center',
    padding: '12px 40px',
  },
});

export const IconBoxStyled = styled('div')({
  width: '48px',
  marginRight: '12px',
});

export const ButtonBoxStyled = styled('div')({
  '@media (max-width: 743px)': {
    marginTop: '24px',
  },
});
